import React from "react";

const TabComp = ({ tabList, activeTab, setActiveTab }) => {
  return (
    <div className="animate-fade-in flex mb-6 p-2 max-w-fit rounded-lg bg-base-200 gap-3 overflow-x-auto whitespace-nowrap transition-all duration-500 ease-in-out transform scale-100">
      {Object.keys(tabList).map((tab) => (
        <button
          key={tab}
          className={`px-4 py-2 rounded-lg transition duration-300 ease-in-out transform ${
            activeTab === tab
              ? "bg-pink-800 text-white shadow-lg scale-105"
              : "text-gray-700 bg-[#FAF5FF] hover:bg-violet-100 hover:scale-105"
          }`}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default TabComp;
